import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { t } from 'ember-intl';
import GeneralCopyToClipboard from 'lumen/components/general/copy-to-clipboard';
import type { HotelAndMarketServiceWithHotel } from 'lumen/services/hotel-and-market';

interface SettingsMyotbCredentialsSignature {
  Args: {};
}

export default class SettingsMyotbCredentials extends Component<SettingsMyotbCredentialsSignature> {
  @service('hotel-and-market')
  declare hotelAndMarketService: HotelAndMarketServiceWithHotel;
  @service declare myotbSs: Services['myotb-ss'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get hotelName() {
    return this.hotelAndMarketService.hotel.hotelinfo?.name;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get otbSelfService() {
    return this.myotbSs?.otbSelfService;
  }

  <template>
    {{#if this.otbSelfService.pmsIntegration.credentials.email}}
      <div class="flex flex-col gap-200">
        <p class="text-300--bold">{{t
            "settings.my_otb.steps.lighthouse_email"
          }}</p>

        <GeneralCopyToClipboard
          @text={{this.otbSelfService.pmsIntegration.credentials.email}}
        />

        <p class="text-300--regular">
          {{t "settings.my_otb.steps.email_subtext" hotelName=this.hotelName}}
        </p>
      </div>
    {{else if this.otbSelfService.pmsIntegration.credentials.username}}
      {{#if this.otbSelfService.pmsIntegration.credentials.password}}
        <div class="flex flex-col gap-200">
          <div class="flex flex-row gap-400">
            <div
              class="myotb-card__content-container__credentials-container flex flex-col gap-200"
            >
              <p class="text-300--bold">{{t "general.username"}}</p>

              <GeneralCopyToClipboard
                @text={{this.otbSelfService.pmsIntegration.credentials.username}}
              />
            </div>

            <div
              class="myotb-card__content-container__credentials-container flex flex-col gap-200"
            >
              <p class="text-300--bold">{{t "general.password"}}</p>

              <GeneralCopyToClipboard
                @text={{this.otbSelfService.pmsIntegration.credentials.password}}
              />
            </div>
          </div>

          <p class="paragraph-300--regular">{{t
              "settings.my_otb.steps.sftp_subtext"
            }}</p>
        </div>
      {{/if}}
    {{/if}}
  </template>
}
